import { Store } from '../../typings';

const getActiveSectionId = (store: Store): string => (store.controls.activeSectionId);

export default getActiveSectionId;
